import React, { lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';

const Home = React.lazy(() => import('./pages/Home'));
const GalleryPage = React.lazy(() => import('./pages/GalleryPages'));
const EventPage = React.lazy(() => import('./pages/EventPages'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const Footer = React.lazy(() => import('./components/Footer/Footer'));

const App = () => {
  return (
    <Router>
      <div className="bg-white min-h-screen">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/about" element={<AboutPage/>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;